import React from "react";
import Banner from "./components/Banner";
import bannerImg from "./assests/products.png";

export default function Products() {
  return (
    <div>
      <Banner
        btype="image"
        src={bannerImg}
        heading="PRODUCTS"
        />
    </div>
  );
}
